import React, { useState } from "react";
import styled from "styled-components";
import Cookies from "js-cookie";

export const STARTUP_AWARDS_EXPIRATION_DATE = "2026-10-21T23:59:59-03:00";
export const STARTUP_AWARDS_STORAGE_KEY = "easygestor_hide_startup_awards_banner_2026";
export const STARTUP_AWARDS_VOTE_URL = "https://influen.cr/votar";

const BannerCard = styled.div`
  width: 100%;
  background-color: #121212;
  color: #ffffff;
  border-radius: 0;
  padding: 8px 24px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
  transition: all 0.2s ease-in-out;

  @media (max-width: 992px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 12px 16px;
    gap: 12px;
  }
`;

const BannerContent = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  flex: 1;

  @media (max-width: 576px) {
    gap: 8px;
  }
`;

const Badge = styled.span`
  background-color: #c6f135;
  color: #000000;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 4px 12px;
  border-radius: 9999px;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1.2;
`;

const BannerText = styled.span`
  color: #f4f4f5;
  font-size: 13.5px;
  line-height: 1.4;
  font-weight: 400;

  .highlight {
    color: #c6f135;
    font-weight: 700;
  }

  @media (max-width: 768px) {
    font-size: 12.5px;
  }
`;

const BannerActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;

  @media (max-width: 992px) {
    width: 100%;
    justify-content: space-between;
  }
`;

const VoteButton = styled.a`
  background-color: #ffffff;
  color: #000000 !important;
  font-size: 13px;
  font-weight: 700;
  padding: 6px 18px;
  border-radius: 9999px;
  text-decoration: none !important;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    background-color: #eaeaea;
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    color: #000000 !important;
    text-decoration: none !important;
  }

  &:active {
    transform: translateY(0);
  }
`;

const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: #a1a1aa;
  cursor: pointer;
  padding: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: color 0.2s ease, transform 0.2s ease;

  &:hover {
    color: #ffffff;
    transform: scale(1.1);
  }

  &:focus {
    outline: none;
  }
`;

export default function StartupAwardsBanner() {
  const [visible, setVisible] = useState(() => {
    try {
      const expirationTimestamp = new Date(STARTUP_AWARDS_EXPIRATION_DATE).getTime();
      if (Date.now() > expirationTimestamp) {
        return false;
      }
      const isDismissedLocal = localStorage.getItem(STARTUP_AWARDS_STORAGE_KEY) === "true";
      const isDismissedCookie = Cookies.get(STARTUP_AWARDS_STORAGE_KEY) === "true";
      if (isDismissedLocal || isDismissedCookie) {
        if (!isDismissedLocal) {
          localStorage.setItem(STARTUP_AWARDS_STORAGE_KEY, "true");
        }
        if (!isDismissedCookie) {
          Cookies.set(STARTUP_AWARDS_STORAGE_KEY, "true", {
            expires: new Date(STARTUP_AWARDS_EXPIRATION_DATE),
          });
        }
        return false;
      }
      return true;
    } catch (e) {
      return true;
    }
  });

  if (!visible) {
    return null;
  }

  const handleClose = () => {
    try {
      localStorage.setItem(STARTUP_AWARDS_STORAGE_KEY, "true");
      Cookies.set(STARTUP_AWARDS_STORAGE_KEY, "true", {
        expires: new Date(STARTUP_AWARDS_EXPIRATION_DATE),
      });
    } catch (e) {
      // Ignore storage errors (ex: private mode quota restrictions)
    }
    setVisible(false);
  };

  return (
    <BannerCard data-testid="startup-awards-banner">
      <BannerContent>
        <Badge>STARTUP AWARDS 2026</Badge>
        <BannerText>
          Somos <span className="highlight">semifinalistas</span> — e seu voto conta. Três indicados da região Norte. Votar leva menos de um minuto.
        </BannerText>
      </BannerContent>
      <BannerActions>
        <VoteButton
          href={STARTUP_AWARDS_VOTE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Votar Grátis &rarr;
        </VoteButton>
        <CloseButton
          type="button"
          onClick={handleClose}
          aria-label="Fechar banner"
          title="Fechar"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="2" y1="2" x2="12" y2="12" />
            <line x1="12" y1="2" x2="2" y2="12" />
          </svg>
        </CloseButton>
      </BannerActions>
    </BannerCard>
  );
}



// WEBPACK FOOTER //
// ./src/components/StartupAwardsBanner/index.jsx